export class Common {
  static compareHelper(order: { key: string; reverse: boolean }[]) {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    return (a: any, b: any) => {
      for (let i = 0; i < order.length; i++) {
        const order_by = order[i].reverse ? 1 : -1
        if (a[order[i].key] < b[order[i].key]) return order_by
        if (a[order[i].key] > b[order[i].key]) return order_by * -1
      }
      return 0
    }
  }

  static isUserSettingMode(): boolean {
    return process.env.VUE_APP_CATEGORY === 'SETTING'
  }
}
